module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 1
// module chunks = 15 16 17 18 19